import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import MailIcon from "@mui/icons-material/Mail";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { ListItemButton } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import { Grid } from "@mui/material";
import ScreenLoader from "../../../shared/ScreenLoader";

import { useDispatch } from "react-redux";
import * as actionTypes from "../../state/actionTypes";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  "&:before": {
    display: "none",
  },
}));

const CustomTypography = styled((props) => <Typography {...props} />)(() => ({
  color: "#50566E",
  fontSize: ".875rem",
  fontWeight: "550",
  lineheight: "16px",
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowRightIcon sx={{ fontSize: "1.8rem" }} />}
    {...props}
  />
))(() => ({
  boxSizing: "border-box",
  height: "34px",
  minHeight: "34px",
  borderTop: "1px solid #CFD7DF",
  borderBottom: "1px solid #CFD7DF",
  backgroundColor: "#F2F4F8",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(90deg)",
    color: "#50566E",
    fontSize: ".875rem",
    fontWeight: "600",
  },
  "& .MuiAccordionSummary-content": {
    color: "#50566E",
    fontSize: ".875rem",
    fontWeight: "550",
    lineheight: "16px",
  },
}));

const SecondaryAccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowRightIcon sx={{ fontSize: "1.8rem" }} />}
    {...props}
  />
))(() => ({
  "& .Mui-expanded": {
    backgroundColor: "#1492AF",
    color: "#ffffff",
  },
  height: "32px",
  minHeight: "34px",
  borderRadius: "4px",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
    color: "#ffffff",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(90deg)",
    color: "#50566E",
    fontSize: ".875rem",
    fontWeight: "600",
  },
  "& .MuiAccordionSummary-content": {
    color: "#50566E",
    fontSize: ".875rem",
    fontWeight: 550,
    lineheight: "16px",
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    color: "#ffffff",
    backgroundColor: "#1492AF",
    fontWeight: 550,
    lineheight: "16px",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingRight: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const SecondaryAccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  width: "100%",
  padding: "0px",
}));

// const dummyMessageTypesArray = [
//   { name: "MT9999", count: 300 },
//   { name: "MT191", count: 198 },
//   { name: "MT950", count: 1290 },
//   { name: "Pacs.008.001.08", count: 289 },
// ];
/**
 *
 * @param {Array} bankBics array of returned bankBics
 * @param {Boolean} loadingMessages loading indicator
 * @param {Object} currentBic current selected bic
 * @param {String} currentMessageStatus current selected status [toSwift,fromSwift,NACK]
 * @param {String} currentType current selected message type
 * @returns
 */
const SegregatedMessages = ({
  loadingMessages,
  currentBic,
  bankBics,
  currentMessageStatus,
  currentType,
}) => {
  const dispatch = useDispatch();

  // const dispatchAction = useCallback((action) => dispatch(action), [dispatch]);

  const [expanded, setExpanded] = useState(null);
  const [secondaryExpanded, setSecondaryExpanded] = useState(null);
  const handleChange = (bic) => (event, newExpanded) => {
    setExpanded(newExpanded ? bic : false);
  };

  const handleChangeSecondaryExapnded = (isExpanded, status) => {
    const index = secondaryExpanded.findIndex((item) => item === status);

    if (index !== -1) {
      setSecondaryExpanded(secondaryExpanded.filter((item) => item !== status));
    } else {
      setSecondaryExpanded([...secondaryExpanded, status]);
    }
  };

  const handleChangeCurrentType = (e) => {
    const newtypeData = JSON.parse(e.currentTarget.id);
    dispatch({
      type: actionTypes.SET_CURRENT_TYPE,
      payload: {
        type: newtypeData.type,
        messageStatus: newtypeData.status,
        bic: expanded,
      },
    });
  };

  useEffect(() => {
    if (
      !loadingMessages &&
      !expanded &&
      !secondaryExpanded &&
      currentBic &&
      currentMessageStatus
    ) {
      setExpanded(currentBic?.bic);
      setSecondaryExpanded([currentMessageStatus]);
    }
  }, [
    currentBic,
    currentMessageStatus,
    expanded,
    loadingMessages,
    secondaryExpanded,
  ]);

  // useEffect(() => {
  //   if (expanded && expanded !== currentBic?.bic)
  //     dispatchAction({ type: actionTypes.SET_CURRENT_BIC, payload: expanded });
  // }, [expanded, dispatchAction, currentBic?.bic]);

  // useEffect(() => {
  //   if (secondaryExpanded && secondaryExpanded !== currentMessageStatus)
  //     dispatchAction({
  //       type: actionTypes.SET_CURRENT_MESSAGE_STATUS,
  //       payload: secondaryExpanded,
  //     });
  // }, [secondaryExpanded, dispatchAction, currentMessageStatus]);

  return (
    <div
      style={{
        minHeight: "100%",
        borderRight: "1px solid #CFD7DF",
        width: "100%",
      }}
    >
      {loadingMessages ? (
        <ScreenLoader />
      ) : !bankBics || !bankBics?.length ? (
        <Typography
          sx={{
            margin: "auto",
            width: "50%",
            paddingTop: "20%",
            color: "#50566E",
            fontWeight: 550,
            fontSize: ".875rem",
            opacity: 0.85,
          }}
        >
          No Messages found
        </Typography>
      ) : (
        bankBics?.map((bankBic) => (
          <Accordion
            key={bankBic.bic}
            expanded={expanded === bankBic.bic}
            onChange={handleChange(bankBic.bic)}
          >
            <AccordionSummary
              aria-controls={`${bankBic.bic}-content`}
              id={`${bankBic.bic}-header`}
            >
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                <Grid item>
                  <Grid container alignItems="center">
                    <Grid item>
                      <AccountBalanceIcon sx={{ fontSize: "1.1rem" }} />
                    </Grid>
                    <Grid item sx={{ marginLeft: "5px" }}>
                      <CustomTypography>{bankBic.bic}</CustomTypography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sx={{
                    height: "24px",
                    width: "24px",
                    borderRadius: " 6px",
                    backgroundColor: "#DBDEE6",
                    textAlign: "center",
                    color: "#50566E",
                  }}
                >
                  {bankBic.messageTypesCount}
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              {bankBic.messageStatuses.map((status) =>
                status.messagesTypes?.length ? (
                  <Accordion
                    key={status.name}
                    expanded={secondaryExpanded?.includes(status.name) || false}
                    onChange={(e, isExpanded) => {
                      handleChangeSecondaryExapnded(isExpanded, status.name);
                    }}
                  >
                    <SecondaryAccordionSummary
                      aria-controls={`${status.name}-content`}
                      id={`${status.name}-header`}
                      sx={{
                        backgroundColor: secondaryExpanded?.includes(
                          status.name
                        )
                          ? "#1492AF"
                          : "#ffffff",
                      }}
                    >
                      <Typography sx={{ fontSize: ".875rem", fontWeight: 550 }}>
                        {status.name}
                      </Typography>
                    </SecondaryAccordionSummary>
                    <SecondaryAccordionDetails>
                      {/* {!status.messagesTypes?.length && (
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Grid item xs={6}>
                            <ListItemText
                              sx={{
                                color: "#50566E",
                                "& .MuiTypography-root": {
                                  fontWeight: "400",
                                  fontSize: ".875rem",
                                },
                                marginLeft: "5px",
                              }}
                            >
                              No messages
                            </ListItemText>
                          </Grid>
                        </Grid>
                      )} */}
                      {status.messagesTypes.map((type) => (
                        <ListItemButton
                          key={type.type}
                          sx={{
                            maxHeight: "32px",
                            height: "32px",
                            width: "100%",
                            "&:hover": { backgroundColor: "#D4EDF3" },
                            backgroundColor:
                              currentType === type.type &&
                              status.name === currentMessageStatus
                                ? "#D4EDF3"
                                : "#fffff",
                          }}
                          id={JSON.stringify({
                            type: type.type,
                            status: status.name,
                          })}
                          onClick={handleChangeCurrentType}
                        >
                          <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Grid item>
                              <Grid
                                container
                                alignItems="center"
                                sx={{ marginLeft: "20px" }}
                              >
                                <Grid item>
                                  <MailIcon
                                    size="small"
                                    fontSize=".875rem"
                                    sx={{ color: "#50566E" }}
                                  />
                                </Grid>
                                <Grid item>
                                  <ListItemText
                                    sx={{
                                      color: "#50566E",
                                      "& .MuiTypography-root": {
                                        fontWeight: "400",
                                        fontSize: ".875rem",
                                      },
                                      marginLeft: "5px",
                                    }}
                                  >
                                    {type.type}
                                  </ListItemText>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item>
                              <Typography
                                sx={{
                                  fontWeight: "400",
                                  fontSize: ".875rem",
                                  color: "#50566E",
                                }}
                              >
                                {type.messagesCount}
                              </Typography>
                            </Grid>
                          </Grid>
                        </ListItemButton>
                      ))}
                    </SecondaryAccordionDetails>
                  </Accordion>
                ) : null
              )}
            </AccordionDetails>
          </Accordion>
        ))
      )}
    </div>
  );
};

export default SegregatedMessages;
